$(document).ready(function () {
  console.log("hfg");

  /* START get height of scrolling announcement bar for the new transparent header positioning */
  var firstAnnouncement = $('.shopify-section-group-header-group .scrolling-announcements').first();
  var announcementHeight = firstAnnouncement.outerHeight();
  $('#HeaderWrapper').css('top', announcementHeight + 'px');
  /* END get height of scrolling announcement bar for the new transparent header positioning */

  /* check for A/B parameter */
  var urlParams = new URLSearchParams(window.location.search); 
  var param = urlParams.get('v'); 
  console.log({ param });
  if ( param == "b" ) {
    $('body').addClass('optimize-b-test');
  }


  setTimeout(function () {
    console.log("manually set transition classes");
    $("body").addClass("loaded").removeClass("unloading");
  }, 1300);

  $(".recharge-subscription-widget").addClass("custom-gapstow-class");
  console.log("custom", $(".custom-subscribe-element"));
  $(".custom-subscribe-element").on("click", function () {
    console.log("custom1");
    var wrapper = $(this).closest(".custom-wrapper");
    $(".custom-wrapper").removeClass("custom-wrapper-active");
    wrapper.addClass("custom-wrapper-active");
    if (wrapper.hasClass("custom-subscribe-wrapper")) {
      console.log("wrapper", wrapper);
      $(".subscription-radio input").click();
    } else {
      $(".onetime-radio input").click();
    }
  });

  $(".modal--quick-shop").on(
    "click",
    ".custom-subscribe-element",
    function (e) {
      console.log("hello");
      var wrapper = $(this).closest(".custom-wrapper");
      console.log("hello", wrapper);

      $(".custom-wrapper").removeClass("custom-wrapper-active");
      wrapper.addClass("custom-wrapper-active");
    }
  );

  // grid-product-type-one-time-only
  $(".grid-product-type-one-time-only .modal--quick-shop").on(
    "click",
    ".btn.add-to-cart",
    function (e) {
      e.preventDefault();
      var parentWrapper = $(this).closest(".modal--quick-shop");
      var qtyEl = parentWrapper.find(".js-qty__num");
      var qty = qtyEl.val();
      var maxQty = parentWrapper.data("max-quantity") || null;
      var variantId = parentWrapper.attr("data-variant-id");
      addItemToCart(variantId, qty, 0, maxQty);
    }
  );

  $(".modal--quick-shop").on(
    "click",
    ".custom-subscribe-wrapper .custom-add-to-cart span",
    function (e) {
      e.preventDefault();
      var parentWrapper = $(this).closest(".modal--quick-shop");
      var qtyEl = parentWrapper.find(".js-qty__num");
      var qty = qtyEl.val();
      var maxQty = parentWrapper.data("max-quantity") || null;
      var variantId = parentWrapper.attr("data-variant-id");
      addItemToCart(variantId, qty, sellingPlanId, maxQty);
    }
  );

  $(".modal--quick-shop").on(
    "click",
    ".custom-onetime-wrapper .custom-add-to-cart span",
    function (e) {
      e.preventDefault();
      var parentWrapper = $(this).closest(".modal--quick-shop");
      var qtyEl = parentWrapper.find(".js-qty__num");
      var qty = qtyEl.val();
      var maxQty = parentWrapper.data("max-quantity") || null;
      var variantId = parentWrapper.attr("data-variant-id");
      addItemToCart(variantId, qty, 0, maxQty);
    }
  );

  $(".modal--quick-shop").on("change", "select", function (e) {
    var shoppingPlanId = this.value;
    var parentWrapper = $(this).closest(".custom-subscribe-wrapper");
    var customATC = parentWrapper.find("[data-custom-subscription-atc]");
    customATC.attr("data-selling-plan-id", shoppingPlanId);
  });

  $(".custom-add-to-cart span").on("click", function (e) {
    e.preventDefault();
    $(".rc-radio--active input").addClass("click-this");
    $(".rc-radio--active input").click();
    var sellingPlanId = $(this).attr("data-selling-plan-id");
    var atcButton = $(".product-block .btn.add-to-cart");
    var atcForm = atcButton.closest("form");
    console.log("atc");
    console.log(atcButton);
    console.log(atcForm);
    console.log(sellingPlanId);
    atcButton.addClass("found-button");
    atcButton.click();
  });
  $("[data-custom-subscription-atcxxx]").on("click", function (e) {
    e.preventDefault();
    var wrapper = $(this).closest(".custom-subscribe-wrapper");
    var select = wrapper.find("select");
    var sellingPlan = select.value;
    console.log({ sellingPlan });
  });

  function addItemToCart(variant_id, qty, selling_plan, max_qty) {
    console.log("gdc addItemToCart");
    if (selling_plan == 0) {
      data = {
        id: variant_id,
        quantity: qty,
        properties: {
          "_max-quantity": max_qty
        }
      };
    } else {
      data = {
        id: variant_id,
        quantity: qty,
        properties: {
          "_max-quantity": max_qty
        },
        selling_plan: selling_plan,
      };
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log("added item to cart");
        //window.location.href = '/cart';
      },
    });
  }


});


https://havenhome-express.myshopify.com/?_ab=0&_fd=0&_sc=1&preview_theme_id=144730489072


document.addEventListener('DOMContentLoaded', function() {
  var elem = document.querySelector('.rotating-text-carousel');
  var autoplaySpeed = parseInt(elem.getAttribute('data-autoplay-speed')); 
  console.log({autoplaySpeed});
  if (elem) {
      var flkty = new Flickity(elem, {
          // options
          fade: true,
          pageDots: false,
          draggable: false,
          adaptiveHeight: true,
          prevNextButtons: false,
          autoPlay: autoplaySpeed,
          wrapAround: true
      });
      window.addEventListener('resize', function() {
        flkty.resize();  // Resize Flickity to adjust to the new container size
      });
  }
  /* client decided against the curtans */

  /* check for Novel app */
  
  /*
  const allElements = document.querySelectorAll('*');

  // Check each element's ID
  allElements.forEach(element => {
      if (element.id.includes('shopify-block-novel')) {
          // Add class 'novel-curtain-container' to the element
          element.classList.add('novel-curtain-container');

          // Create two new div elements for the curtains
          const rightCurtain = document.createElement('div');
          rightCurtain.className = 'novel-curtain novel-curtain-right';

          const leftCurtain = document.createElement('div');
          leftCurtain.className = 'novel-curtain novel-curtain-left';

          // Append the new divs to the current element
          element.appendChild(leftCurtain);
          element.appendChild(rightCurtain);
      }
  });
*/
});



/* custom select element */
var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
//console.log("start custom class", x, l);
var arrowIcon = `<svg data-v-af3fed16="" width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.16949 9.69475L1.02825 10.5369C1.25424 10.7054 1.61582 10.7054 1.79661 10.5369L10.0226 2.91526L18.2034 10.5369C18.3842 10.7054 18.7458 10.7054 18.9718 10.5369L19.8305 9.69475C20.0565 9.48421 20.0565 9.18945 19.8305 8.9789L10.3842 0.136091C10.1582 -0.0323434 9.84181 -0.0323434 9.61582 0.136091L0.16949 8.9789C-0.056498 9.18944 -0.056498 9.4842 0.16949 9.69475Z" fill="#266041"></path></svg>`;
var icon = `<svg data-custom-hook="find-me" class="icon-class" data-v-af3fed16="" width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3666 1.41704C10.5959 1.26309 10.6569.952447 10.503.723201 10.349.493955 10.0384.432916 9.80914.586866L10.3666 1.41704ZM8.82927 5.57362C8.98323 5.80286 9.29387 5.8639 9.52311 5.70995 9.75236 5.556 9.8134 5.24536 9.65945 5.01611L8.82927 5.57362ZM7.51967 2.72664 7.24092 2.31156C7.01167 2.46551 6.95063 2.77615 7.10458 3.0054L7.51967 2.72664ZM9.80914.586866 7.24092 2.31156 7.79842 3.14173 10.3666 1.41704 9.80914.586866ZM7.10458 3.0054 8.82927 5.57362 9.65945 5.01611 7.93476 2.44789 7.10458 3.0054ZM5.11702 17.6358C4.89254 17.7966 4.84092 18.1089 5.00174 18.3334 5.16255 18.5579 5.4749 18.6095 5.69938 18.4487L5.11702 17.6358ZM6.52796 13.4346C6.36714 13.2101 6.0548 13.1585 5.83031 13.3193 5.60583 13.4801 5.55421 13.7925 5.71503 14.017L6.52796 13.4346ZM7.92308 16.2407 8.21426 16.6471C8.43874 16.4863 8.49036 16.174 8.32954 15.9495L7.92308 16.2407ZM5.69938 18.4487 8.21426 16.6471 7.6319 15.8342 5.11702 17.6358 5.69938 18.4487ZM8.32954 15.9495 6.52796 13.4346 5.71503 14.017 7.51661 16.5318 8.32954 15.9495Z" fill="#595959"></path> <path fill-rule="evenodd" lip-rule="evenodd" d="M4.07801 3.39201C1.94276 4.59085 0.5 6.87694 0.5 9.5C0.5 13.366 3.63401 16.5 7.5 16.5C7.59475 16.5 7.68907 16.4981 7.78291 16.4944L7.50173 15.5C7.50115 15.5 7.50058 15.5 7.5 15.5C4.18629 15.5 1.5 12.8137 1.5 9.5C1.5 7.33775 2.64376 5.44265 4.35927 4.38669L4.07801 3.39201ZM10.8501 14.4784C12.4487 13.4005 13.5 11.573 13.5 9.5C13.5 6.26909 10.9463 3.63464 7.7472 3.505L7.46304 2.5001C7.47536 2.50003 7.48767 2.5 7.5 2.5C11.366 2.5 14.5 5.63401 14.5 9.5C14.5 12.0351 13.1524 14.2555 11.1344 15.4838L10.8501 14.4784Z" fill="#595959"></path></svg>`;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  //console.log("start custom select", selElmnt, ll, icon);
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  var selectedHtml =
    "<span>" +
    selElmnt.options[selElmnt.selectedIndex].innerHTML +
    "</span><span class='dropdown-arrow'>" +
    arrowIcon +
    "</span>";
  a.innerHTML = selectedHtml;
  //console.log(selElmnt.options[selElmnt.selectedIndex].innerHTML);
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < ll; j++) {
    //console.log("loop", j, ll, {icon});
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML =
      icon +
      "<span class='custom-delivery-text'>" +
      selElmnt.options[j].innerHTML +
      "</span>";
    c.addEventListener("click", function (e) {
      console.log("click", e);
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      console.log({ s }, { h }, { sl });
      for (i = 0; i < sl; i++) {
        var temp1 = s.options[i].innerHTML;
        var temp2 = this.innerHTML;
        var temp3 = this.getElementsByClassName("custom-delivery-text")[0];
        var temp4 = temp3.innerHTML;
        //console.log({temp1}," vs ", {temp2}," and ",{temp4});
        /* if (s.options[i].innerHTML == this.innerHTML) { */
        if (s.options[i].innerHTML == temp3.innerHTML) {
          s.selectedIndex = i;
          /*h.innerHTML = temp3.innerHTML;*/
          h.innerHTML =
            "<span>" +
            temp3.innerHTML +
            "</span><span class='dropdown-arrow'>" +
            arrowIcon +
            "</span>";
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          console.log({ y }, { yl });
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    console.log(a);
    var selectValue = $(".custom-select select").val();
    console.log({ selectValue });
    $(".rc-selling-plans-dropdown__select").toggleClass("toggleClass");
    $(
      ".rc-selling-plans-dropdown__select option[value='" + selectValue + "']"
    ).prop("selected", true);
    $(".rc-selling-plans-dropdown__select").trigger("change");
    $('[name="selling_plan"]').val(selectValue);
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

var target = document.querySelector("[data-product-blocks]");
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    //console.log(mutation);
    // Check if the mutation added any new nodes
    if (mutation.addedNodes.length > 0) {
      // Loop through the added nodes
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        var node = mutation.addedNodes[i];
        // Check if the node is an element and if it has a class containing the number 945
        //var t1 = node.className;
        //var dataAttribute = node.getAttribute('data-custom-hook');
        //console.log(node);
        //console.log(node.className);
        //console.log({t1});
        //console.log({dataAttribute});
        //if ( t1.baseVal ) {
        //  console.log("baseVal", t1.baseVal)
        //} else {
        //  console.log("no baseVal");
        //}
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          !node.hasAttribute("data-custom-hook")
        ) {
          if (node.className.indexOf("rc-widget") > -1) {
            console.log("rc go to town");
            var subPrice = $(".subscription-radio .rc-radio__price").html();
            $(".purchase-type-price-subscription").html(subPrice);
          }
        }
      }
    }
  });
});
const config = { attributes: true, childList: true, subtree: true };

if (target) {
  observer.observe(target, config);
}

// added by Brittany 09/22/2023
// listen for cart change using Rebuy's event listener, https://developers.rebuyengine.com/reference/cart-event-listeners

// document.addEventListener('cart:updated', (event) => {
//   alert("other cart")
// });
let cartUpdatedResolver;
const cartUpdatedPromise = new Promise((resolve) => {
    cartUpdatedResolver = resolve;
});

document.addEventListener('cart:updated', (event) => {
  if (cartUpdatedResolver) {
      cartUpdatedResolver();
      // Ensure the resolver is nullified or reset after being called, 
      // so it doesn't get called more than once.
      cartUpdatedResolver = null;
  }
});

if (document.querySelector('#CartPageForm')) {
  document.addEventListener('rebuy:cart.ready', function() {
    // Now we know that window.Rebuy.Cart is ready to be used.
    handleCartUpdates();
  
    document.addEventListener('rebuy:cart.change', async (event) => {
        await cartUpdatedPromise;
        setTimeout(() => {
          handleCartUpdates();
        }, 100);
    });
  });
} else {
  document.addEventListener('rebuy:cart.change', async (event) => {
    handleCartUpdates();
  });
}
document.addEventListener('rebuy:smartcart.show', (event) => {
  handleCartUpdates();
});

function handleCartUpdates() {
  let maxedOutItems = checkCart()
  let cartItems = window.Rebuy.Cart.getItems()
  //console.log('MAXED OUT ITEMS', maxedOutItems)
  //console.log('CART', cartItems)
  // clear out any existing messages first
  let existingMessages = document.querySelectorAll('.maxed-out-message')
  if(existingMessages.length > 0) {
    console.log("clearing messages")
    existingMessages.forEach(message => {
      message.remove()
    })
  }
  // if there are maxed out items and the class rebuy-modal-visible exists on the body element, add   a message to the cart element with the class `product-${item.handle}`
  if(maxedOutItems.length > 0 && document.body.classList.contains('rebuy-modal-visible') ||   maxedOutItems.length > 0 && document.querySelector('#CartPageForm')) {
    maxedOutItems.forEach(item => {
      let productElement = document.querySelector(`.product-${item.handle}`)
      if(productElement) {
        // if message for this item doesn't already exist, add it
        if(!productElement.querySelector('.maxed-out-message')) {
          let message = document.createElement('div')
          message.classList.add('maxed-out-message')
          message.innerHTML = `<p>You've reached the maximum quantity allowed for this item.</p>`
          productElement.appendChild(message)
        }
        // if js-qty__adjust--plus exists, disable it
        let plusButton = productElement.querySelector('.js-qty__adjust--plus')
        if(plusButton) {
          if (item.properties["_max-quantity"] <= item.quantity) {
            plusButton.setAttribute('disabled', true);
          } else {
            plusButton.removeAttribute('disabled');
          }
        }
      }
    })
  }
}

// create a function to check the cart for items where the line item property "_max-quantity" is equal to the quantity
function checkCart() {
  if (!window.Rebuy || !window.Rebuy.Cart) {
    console.error("Rebuy or Rebuy.Cart is not defined!");
    return [];
}

let Cart = window.Rebuy.Cart;
let cartItems = Cart.getItems();
let maxedOutItems = [];

cartItems.forEach(item => {
    //console.log(`Checking item ${item.handle}, variant id: ${item.variant_id}, quantity: ${item.quantity}, max: ${item.properties["_max-quantity"]}`);

    if (item.properties["_max-quantity"] == item.quantity) {
        //console.log(`Max quantity reached for ${item.handle}`);
        maxedOutItems.push(item);
    }
    
    if (item.properties["_max-quantity"] && item.properties["_max-quantity"] < item.quantity) {
        //console.log(`Adjusting quantity for ${item.handle} to max`);
        Cart.setItemQuantity(item, Number(item.properties["_max-quantity"]));
    }
});

return maxedOutItems;
}



/* variants as products */
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.product-family-wrapper .product-family-link');
  const familyVarietySpan = document.getElementById('familyVariety');
  if (familyVarietySpan) {
    const originalText = familyVarietySpan.getAttribute('data-page-variety');
  }
  let mouseEnterTimeout;

  links.forEach(link => {
    link.addEventListener('mouseenter', function() {
      // Clear any existing timeout to prevent unwanted text changes
      clearTimeout(mouseEnterTimeout);
      console.log('Mouse entered', this.getAttribute('data-family-variety'));
      // Set a new timeout
      mouseEnterTimeout = setTimeout(() => {
        const variety = this.getAttribute('data-family-variety');
        console.log('Changing text to:', variety);
        familyVarietySpan.textContent = variety;
      }, 30); // Delay in milliseconds, adjust as needed
    });

    link.addEventListener('mouseleave', function() {
      // Clear the timeout if mouse leaves before the delay is over
      clearTimeout(mouseEnterTimeout);
      console.log('Mouse left', this.getAttribute('data-family-variety'));
      console.log('Resetting text to original:', originalText);
      // Immediately reset the text
      familyVarietySpan.textContent = originalText;
    });
  });
});

/* new subscriptions cards */
function addItemToCartNewSubscriptions(variant_id, qty, selling_plan) {
  var data = {
      id: variant_id,
      quantity: qty
  };

  if (selling_plan !== 0) {
      data.selling_plan = selling_plan;
  }

  jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
          console.log("added item to cart");
          //window.location.href = '/cart';
      },
  });
}

document.addEventListener('click', function(event) {
  console.log('click', event.target);
  if (event.target.classList.contains('subscriptions-card-atc')) {
      const subscriptionsOptions = event.target.closest('.subscription-card').querySelector('.product-subscriptions-options');
      const variantId = event.target.getAttribute('data-variant-id');
      if (subscriptionsOptions) {
          const isOpen = subscriptionsOptions.classList.contains('subscription-options-open');
          const selectElement = subscriptionsOptions.querySelector('select');

          if (!isOpen) {
              // Add to cart with selling plan 0
              addItemToCartNewSubscriptions(variantId, 1, 0);
          } else if (selectElement) {
              // Add to cart with selected selling plan
              addItemToCartNewSubscriptions(variantId, 1, selectElement.value);
          }
      } else {
        // No subscription options - add as one-time purchase
        addItemToCartNewSubscriptions(variantId, 1, 0);
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var wrapperSubCards = document.querySelector('.subscription-cards-wrapper');
  var flktySubs;
  var lastWidth;

  function initFlickity() {
    console.log("initFlickitySubs");
    if (flktySubs) {
      flktySubs.destroy();
    }
    flktySubs = new Flickity(wrapperSubCards, {
      resize: true,
      wrapAround: true,
      cellAlign: 'left',
      on: {
        ready: function() {
          console.log('Flickity ready');
          console.log(wrapperSubCards.offsetHeight);
          //setWrapperHeightSubs();
        }
      },
      imagesLoaded: true
    });
  }

  function setWrapperHeightSubs() {
    var currentHeight = wrapperSubCards.offsetHeight;
    console.log({currentHeight});
    // Set the height as an inline style to prevent collapsing
    wrapperSubCards.style.height = currentHeight + 'px';
  }

  function resizeTitles() {
    var titles = wrapperSubCards.querySelectorAll('.product-title h2');
    var maxHeight = 0;
    titles.forEach(function(title) {
      var titleHeight = title.getBoundingClientRect().height;
      if (titleHeight > maxHeight) {
        maxHeight = titleHeight;
      }
    });
    titles.forEach(function(title) {
      title.style.height = maxHeight + 'px';
    });
  }

  /*
    function handleResize() {
      initFlickity();
      resizeTitles();
    }
*/

  function handleResize() {
    console.log("handle resize");
    var newWidth = window.innerWidth;
    if (newWidth != lastWidth) {
      console.log("reinitflickity");
      lastWidth = newWidth;
      initFlickity();
      resizeTitles();
    } else {
      console.log("window width did not change so do not reinitflickity");
    }
  }



  if (wrapperSubCards) {
    initFlickity();
    resizeTitles();
    window.addEventListener('resize', handleResize);
  }

  var prevButton = document.querySelector('.custom-subs-carousel-prev');
  var nextButton = document.querySelector('.custom-subs-carousel-next');

  if (prevButton) {
      prevButton.addEventListener('click', function() {
          flktySubs.previous();
      });
  }

  if (nextButton) {
      nextButton.addEventListener('click', function() {
          flktySubs.next();
      });
  }

  var wrapperPress = document.querySelector('.press-carousel');
  var flktyPress;
  var prevButtonAttached = false;
  var nextButtonAttached = false;

  console.log({wrapperPress});

  function initFlickityPress() {
    if (flktyPress) {
      flktyPress.destroy();
    }
    flktyPress = new Flickity(wrapperPress, {
      wrapAround: true,
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: false,
      imagesLoaded: true
    });
    var prevButton = document.querySelector('.custom-press-carousel-prev');
    var nextButton = document.querySelector('.custom-press-carousel-next');

    if (prevButton && !prevButtonAttached) {
      prevButton.addEventListener('click', function () {
        console.log("go to previous");
        flktyPress.previous();
      });
      prevButtonAttached = true;
    }
  
    if (nextButton && !nextButtonAttached) {
      nextButton.addEventListener('click', function () {
        console.log("go to next");
        flktyPress.next();
      });
      nextButtonAttached = true;
    }
  }

    if (wrapperPress) {
      initFlickityPress();
      //window.addEventListener('resize', initFlickityPress);
    }

});





((document, window) => {
  // Placeholder for the setupCollectionControls function
  function setupCollectionControls() {
    // Your setup logic here
    console.log('setupCollectionControls called');
  }

  const okeRenderedHandler = function(e) {

    if (e.detail.widget === 'badge') {
      const observer = new MutationObserver((mutations, obs) => {
        const reviewCountElement = document.querySelector('.oke-minimalBadge-count');
        const averageRatingElement = document.querySelector('.oke-minimalBadge-stars .oke-a11yText');
        const starsForegroundElement = document.querySelector('.oke-minimalBadge-stars');

        if (reviewCountElement && averageRatingElement && starsForegroundElement) {
          // Extract the review count
          const reviewCount = reviewCountElement ? reviewCountElement.textContent.trim() : 'N/A';
          
          // Extract the average rating
          const averageRating = averageRatingElement ? averageRatingElement.textContent.match(/Rated ([0-9.]+) out of 5 stars/)[1] : 'N/A';
          
          // Extract the HTML for the oke-stars-foreground
          const starsForegroundHTML = starsForegroundElement ? starsForegroundElement.innerHTML : 'N/A';

          // Find the #myBadgeCopy element
          const myBadgeCopyElement = document.getElementById('myBadgeCopy');
          if (myBadgeCopyElement) {
            // Inject the starsForegroundHTML
            const starsDiv = document.createElement('div');
            starsDiv.innerHTML = starsForegroundHTML;
            myBadgeCopyElement.appendChild(starsDiv);

            // Create and inject the rating and review count div
            const ratingDiv = document.createElement('div');
            ratingDiv.textContent = `${averageRating} / 5.0 (${reviewCount} reviews and counting!)`;
            myBadgeCopyElement.appendChild(ratingDiv);
          }

          setupCollectionControls();
          
          // Stop observing once we've got the required elements
          obs.disconnect();
        }
      });

      // Start observing the document for changes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  document.addEventListener('oke-rendered', okeRenderedHandler);
})(document, window);




